























































































// Vue
import Vue, { PropType } from "vue";
import { mapActions, mapGetters } from "vuex";
// Vuelidate
import { required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
// Models
import { CreateQuarry, QuarryModel } from "@/core/api/apiClient";
// Services
import AdminService from "../../Admin.service";

export default Vue.extend({
  name: "UpdateQuarryDialog",
  mixins: [validationMixin],
  components: {},
  props: {
    quarry: Object as PropType<QuarryModel>
  },

  data() {
    return {
      dialog: false,
      isLoading: false,

      // Used for creating new Quarries
      nextIndex: undefined as number | undefined,

      index: undefined as number | undefined,
      name: undefined as string | undefined,
      address: undefined as string | undefined | null
    };
  },

  validations: {
    name: { required }
  },

  methods: {
    ...mapActions("appMessages", {
      ADD_ERROR_MESSAGE: "ADD_ERROR_MESSAGE",
      ADD_SUCCESS_MESSAGE: "ADD_SUCCESS_MESSAGE"
    }),

    initialize(): void {
      this.getNextIndex();

      if (this.quarry) {
        this.index = this.quarry.index;
        this.name = this.quarry.name;
        this.address = this.quarry.address ?? null;
      }
    },

    getNextIndex(): void {
      AdminService.getAllQuarries(this.currentUser.clientId).then((data: QuarryModel[]) => {
        if (!data.length) {
          this.nextIndex = 0;
          return;
        }
        this.nextIndex = data.length;
      });
    },

    submit(): void {
      if (!this.name) return;

      this.isLoading = true;

      // Create new Quarry
      if (!this.quarry) {
        const payload = new CreateQuarry({
          index: this.index ?? this.nextIndex!,
          name: this.name,
          address: this.address ?? undefined
        });

        AdminService.createQuarry(this.currentUser.clientId, payload)
          .then(() => {
            this.$emit("refresh-quarries");
            this.close();
            this.ADD_SUCCESS_MESSAGE("Quarry successfully created.");
          })
          .catch((error) => {
            console.log(error);
            this.ADD_ERROR_MESSAGE("Error creating quarry. Please try again.");
          })
          .finally(() => {
            this.isLoading = false;
          });
      }

      // Update existing Quarry
      else {
        const payload = new QuarryModel({
          quarryId: this.quarry.quarryId,
          clientId: this.quarry.clientId,
          index: this.index ?? this.nextIndex!,
          name: this.name,
          address: this.address ?? undefined
        });

        AdminService.updateQuarry(this.currentUser.clientId, payload)
          .then(() => {
            this.$emit("refresh-quarries");
            this.close();
            this.ADD_SUCCESS_MESSAGE("Quarry successfully updated.");
          })
          .catch((error) => {
            console.log(error);
            this.ADD_ERROR_MESSAGE("Error updating quarry. Please try again.");
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    },

    close(): void {
      this.name = undefined as string | undefined;
      this.address = undefined as string | undefined;

      this.$v.$reset;
      this.dialog = false;
    }
  },

  computed: {
    ...mapGetters({ currentUser: "currentUser" }),

    nameErrors(): string[] {
      const errors: string[] = [];
      if (!this.$v.$dirty) return errors;
      !this.$v.name.required && errors.push("Name is required");
      return errors;
    }
  }
});
